import * as v from "valibot";

import { TanstackNotfoundComponent } from "@/components/tanstack-notfound-component";
import { Member } from "@/features/members/member";

const searchSchema = v.object({
  view: v.optional(v.picklist(["check-ins", "guardmes", "incidents"] as const)),
});

export const Route = createFileRoute({
  notFoundComponent: TanstackNotfoundComponent,
  component: Member,
  validateSearch: searchSchema,
});
